(function(){
  if (window.__duloraHomeInit) return; window.__duloraHomeInit = true;
  var run = function(){
    var els = Array.prototype.slice.call(document.querySelectorAll('.fi'));
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('vis');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('vis'); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    els.forEach(function(e){ io.observe(e); });
  };
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  // Theme editor re-renders section DOM without re-executing this script; re-observe the fresh elements
  document.addEventListener('shopify:section:load', run);
})();
